import React from 'react';

import getDefaultTitle from '../../../modules/getDefaultTitle';
import Filters from '../../GenericComponents/Filters/Filters';
import Footer from '../../GenericComponents/Footer/Footer';
import { HawkWidgetContext } from '../../GenericComponents/HawkWidget/HawkWidgetContext';

import ReviewContractsItems from './ReviewContractsItems';

const ReviewContracts: React.FC = () => (
  <HawkWidgetContext.Consumer>
    {(value): JSX.Element => {
      const {
        loading,
        widgetTitle,
        data,
        models,
        translate,
        genericSharedComponents: { HawkTabs, Spinner, Title, LazyImage },
        site,
      } = value;

      return (
        <>
          {loading && <Spinner site={site} LazyImage={LazyImage} />}
          <Title
            {...{
              title:
                widgetTitle ||
                translate('reviewDefaultTitle', [
                  getDefaultTitle(data, models as Record<string, number>),
                ]),
            }}
          />
          <Filters />
          <HawkTabs />
          <ReviewContractsItems />
          <Footer
            {...{
              showDescription: true,
              showPoweredBy: true,
            }}
          />
        </>
      );
    }}
  </HawkWidgetContext.Consumer>
);

export default ReviewContracts;
